// Unauthenticated read-only link API (docs/sharing-links.md §2). No session, no CSRF, no cookies sent
// (`credentials: 'omit'`), nothing stored on the device (no IndexedDB, no service-worker caching: no-store).
export interface PublicTask {
  id: string; title: string; notes: string; completed: boolean; deadline: string | null; tags: string[];
  checklist: Array<{ id: string; text: string; done: boolean }>;
  attachments: Array<{ id: string; name: string; size: number; mime?: string }>;
  created_at: string; added_by: string;
}
export interface PublicView {
  brand: { name: string }; project: { name: string }; shared_by: { name: string };
  scope: { type: 'project' | 'list' | 'tag'; list_id: string | null; tag: string | null };
  lists: Array<{ id: string; name: string; tasks: PublicTask[] }>; truncated: boolean;
}
export type PublicResult = { ok: true; view: PublicView } | { ok: false; reason: 'unavailable' | 'rate_limited' | 'network' };

/** Token from a `/s/{token}` path (the token is `{uuid}.{base64url}`), or null. */
export function shareTokenFromPath(path: string): string | null {
  const m = /^\/s\/([A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)?)\/?$/.exec(path);
  return m ? m[1]! : null;
}

export async function fetchPublicLink(token: string): Promise<PublicResult> {
  let res: Response;
  try { res = await fetch('/api/v1/public/links/' + encodeURIComponent(token), { credentials: 'omit', cache: 'no-store', headers: { Accept: 'application/json' } }); }
  catch { return { ok: false, reason: 'network' }; }
  if (res.ok) return { ok: true, view: (await res.json()) as PublicView };
  return { ok: false, reason: res.status === 429 || res.status === 503 ? 'rate_limited' : 'unavailable' };
}

export const publicFileUrl = (token: string, fileId: string): string => '/api/v1/public/links/' + encodeURIComponent(token) + '/files/' + encodeURIComponent(fileId);

/** Brand display name for the "Open <brand>" button when the link itself is unavailable. */
export async function fetchBrandName(): Promise<string | null> {
  try { const r = await fetch('/api/v1/brand', { credentials: 'omit', cache: 'no-store' }); if (!r.ok) return null; return ((await r.json()) as { display_name?: string }).display_name || null; }
  catch { return null; }
}
